import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Container = styled(Grid)(({ theme }) => ({
  height: "400px",
  width: "100%",
  backgroundColor: theme.palette.background.default,

  ".MuiDataGrid-cell--withRenderer.MuiDataGrid-cell": {
    overflow: "visible",
  },
}));
